export default __webpack_public_path__ + "static/media/Shapes_03.040f3af2.png";